import undelegateListener from '../../off/_undelegatelistener.js';
import triggerOne from '../../trigger/_triggerone.js';
import forEach from '../../_helpers/foreach.js';
// the function is called when something is removed from an array
// it undelegates asterisk listener from removed items unless the array still holds them
export default function arrayRemoveHandler(_ref, _temp) {
  var removed = _ref.removed;
  var _ref2 = _temp === void 0 ? triggerOne.latestEvent.info.delegatedData : _temp,
    path = _ref2.path,
    name = _ref2.name,
    callback = _ref2.callback,
    context = _ref2.context,
    info = _ref2.info,
    object = _ref2.object;
  forEach(removed, function (item) {
    if (item && typeof item === 'object' && Array.prototype.indexOf.call(object, item) === -1) {
      undelegateListener(item, path, name, callback, context, info);
    }
  });
}